import {CheckoutLinkActionType} from './CheckoutLinkActionHelper';
import React, {useContext, useState} from 'react';
import {AlertContext} from '../../../components/contexts/WithAlertContext';
import {useTranslation} from 'react-i18next';
import {CheckoutLinksDataContext} from '../CheckoutLinksDataContext';
import {MenuItem} from '@material-ui/core';
import DeletePaymentLinkDialog from '../dialogs/DeletePaymentLinkDialog';
import CheckoutLinkService from '../../../services/CheckoutLinkService';

const CheckoutLinkDeleteAction = React.forwardRef<HTMLLIElement, CheckoutLinkActionType>(({ checkoutLink, setMenuAnchor, label }, ref) => {
  const [openDialog, setOpenDialog] = useState(false);
  const { reload } = useContext(CheckoutLinksDataContext);
  const alerting = useContext(AlertContext);

  const { t } = useTranslation('payments');

  const deletePaylink = () => {
    CheckoutLinkService.deleteCheckoutLink(checkoutLink.id).then((res) => {
      if (res) {
        setOpenDialog(false);
        alerting.sendAlert('success', t('paylink deleted successfully'));
        reload();
      }
    });
  };

  return (
    <>
      <MenuItem
        ref={ref}
        onClick={() => {
          setMenuAnchor(null);
          setOpenDialog(true);
        }}
      >
        {label}
      </MenuItem>

      {openDialog && <DeletePaymentLinkDialog open={openDialog} onClose={() => setOpenDialog(false)} onDelete={deletePaylink} />}
    </>
  );
});

export default CheckoutLinkDeleteAction;
